export default __webpack_public_path__ + "static/media/suggestion-chips-watson-dialog1.69636038.png";